<template>
  <b-navbar toggleable="md" type="light" variant="white" fixed="top">
    <b-container>
      <b-navbar-brand :to="{ name: 'home' }">
        <c-img width="180px" src="/img/logo-punch-black.png" alt="YouWish" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <div class="ml-auto d-md-none">
          <sidebar />
        </div>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
import Sidebar from '@/views/layouts/Sidebar.vue';

export default {
  name: 'top',
  components: { Sidebar },
};
</script>
